import React from 'react'
import {
  formatPriceCents,
  negative,
  showDescription,
  showValue,
} from 'sidecar-utility-library'

import StatusTag from '../../StatusTag'

import enhance from './enhance'
import {
  CheckInfoContainer,
  Info,
  ListBillingItem,
  DateStack,
  Title,
  Transactions,
  TransactionItem,
  Value,
  Wrapper,
  Link,
  ClickableLink,
} from './styles'
import InfoLink from './InfoLink'
import RollUp from './RollUp'

const Component = ({
  billingCycleEndDate,
  billingCycleStartDate,
  className,
  date,
  description,
  expenseUuid,
  handlers = {},
  info = [],
  link = {},
  memberApp,
  memberUuid,
  policyUuid,
  title,
  transactionIsCheck = false,
  type,
  value,
  checkDetails,
  flag,
  productType,
  // roll up functionality
  expanded,
  grouped,
  handleRollUpView,
  subTransactions = [],
  masterPolicyUuid,
  redactLinkData = false,
}) => {
  const { checkStatusModalHandler, checkStatusHandler } = handlers

  let checkNumber
  let checkPayableTo
  let checkSendToAddress
  let checkUuid

  if (transactionIsCheck)
    [checkNumber, checkPayableTo, checkSendToAddress, checkUuid] = info

  return (
    <ListBillingItem className={className}>
      {date && (
        <DateStack
          data-testid="info_dates"
          date={date}
          expanded={expanded}
          utc
        />
      )}

      <Wrapper>
        <Transactions>
          <TransactionItem>
            <Title>{title}</Title>
            <React.Fragment>
              {transactionIsCheck && (
                <Info>
                  <CheckInfoContainer>
                    {checkNumber} ·{' '}
                    {checkStatusModalHandler && (
                      <ClickableLink
                        onClick={checkStatusModalHandler(checkUuid)}
                      >
                        <StatusTag
                          status="neutral"
                          style={{ marginLeft: '0.625rem' }}
                        >
                          View Status
                        </StatusTag>
                      </ClickableLink>
                    )}
                    {checkStatusHandler && flag && (
                      <Link
                        status="neutral"
                        onClick={checkStatusHandler(checkDetails)}
                      >
                        {' '}
                        {'View Status'}
                      </Link>
                    )}
                    {checkStatusHandler && !flag && (
                      <span>
                        Requested. Check will be mailed in 3-5 business days.
                      </span>
                    )}
                  </CheckInfoContainer>
                  <CheckInfoContainer>
                    <span>{checkPayableTo}</span>
                  </CheckInfoContainer>
                  <CheckInfoContainer>
                    <span>{checkSendToAddress}</span>
                  </CheckInfoContainer>
                </Info>
              )}
              {!transactionIsCheck && (
                <React.Fragment>
                  {showDescription(type) && <Info>{description}</Info>}
                  {((grouped && type === 'ACCOUNT_ENROLLMENT_PAYMENT') ||
                    !grouped) &&
                    info.length > 0 &&
                    info.map((_info, index) => (
                      <Info
                        key={`ListBillingItem-subLabel-${index}`}
                        data-heap-redact-text={redactLinkData}
                      >
                        {_info}
                      </Info>
                    ))}
                </React.Fragment>
              )}
            </React.Fragment>
          </TransactionItem>

          {showValue(type) && (
            <Value expanded={expanded} negative={negative.includes(type)}>
              {formatPriceCents(value)}
            </Value>
          )}
        </Transactions>

        {/* if there's more info via a roll up view, load that extra info */}
        {grouped && type !== 'ACCOUNT_ENROLLMENT_PAYMENT' && (
          <RollUp
            billingCycleEndDate={billingCycleEndDate}
            billingCycleStartDate={billingCycleStartDate}
            expanded={expanded}
            handleRollUpView={handleRollUpView}
            subTransactions={subTransactions}
            productType={productType}
          />
        )}

        <Info>
          <InfoLink
            handlers={handlers}
            link={link}
            memberApp={memberApp}
            subTransactions={subTransactions}
            redactLinkData={redactLinkData}
            uuids={{ expenseUuid, memberUuid, policyUuid, masterPolicyUuid }}
          />
        </Info>
      </Wrapper>
    </ListBillingItem>
  )
}

Component.displayName = 'ListBillingItem'

export default enhance(Component)
